import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { SlotController } from 'src/components/controllers/slot-controller';
import '../../base/outline-link/outline-link';
import componentStyles from './idb-social-icon-button.css.lit';
import { classMap } from 'lit/directives/class-map.js';

/**
 * The Idb Social Icon button component
 * @element idb-social-icon-button
 */
@customElement('idb-social-icon-button')
export class IdbSocialIcon extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, false);

  @property({ type: String, attribute: 'icon-name' })
  iconName: string;

  /**
   * The social media url that the icon will link to
   */
  @property({ type: String, attribute: 'url' })
  url: string;

  /**
   * The aria label for the link
   */
  @property({ type: String, attribute: 'link-aria-label' })
  linkAriaLabel: string;

  /**
   * If this icon is used in the footer
   */
  @property({ type: Boolean, attribute: 'footer' })
  footer: boolean;

  protected firstUpdated(): void {
    if (!this.iconName) {
      throw new Error('icon name is required');
    } else if (!this.url) {
      throw new Error('url is required');
    } else if (!this.linkAriaLabel) {
      throw new Error('link-aria-label is required for accessibility');
    }
  }

  render(): TemplateResult {
    const wrapperClasses = classMap({
      'wrapper': true,
      'social-icon--footer': this.footer,
      [this.iconName]: true,
    });

    const size: string = this.footer ? '24px' : '48px';

    return html`
    <div class="${wrapperClasses}">
      <outline-link
      link-href=${this.url}
      link-target="_blank"
      link-aria-label=${this.linkAriaLabel}
      >
        <outline-icon library="fa" name="${[
          this.iconName,
        ]}" class="mr-2" size="${size}"></outline-icon>
    </outline-link>
  </div>
    `;
  }
}
